import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useTrans } from "../../../../hooks";
import { FormValidation } from "../FormValidation";
import ContestFormField from "../ContestFormField";
import {
  requiredField,
  maxCharLengthField,
  minCharLengthField
} from "../helpers";
import {
  PLOT_SUMMARY_CHARACTER_MAX,
  PLOT_SUMMARY_CHARACTER_MIN
} from "../constants";
import ErrorField from "./ErrorField";

const PlotSummaryField = ({
  form,
  disableForm,
  onFormChange,
  fieldStatus,
  submitted
}) => {
  const { trans } = useTrans();

  const title = trans("Plot summary");

  const subtitle = (
    <div
      className="subtitle"
      dangerouslySetInnerHTML={{
        __html: /* prettier-ignore */ trans("Provide a third-person summary of your story (approx. 500 words). Ensure you include all major plot points, key character arcs, and the final resolution, <strong>including spoilers</strong>.")
      }}
    />
  );

  const errorCondition =
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "plotSummary" &&
        fieldStatus.fieldName !== "" &&
        submitted)) &&
    form.plotSummary === "";

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <FormValidation
        validationRules={[
          requiredField(trans),
          minCharLengthField(PLOT_SUMMARY_CHARACTER_MIN, trans),
          maxCharLengthField(PLOT_SUMMARY_CHARACTER_MAX, trans)
        ]}
      >
        {({ ref, errorMessage, className }) => (
          <React.Fragment>
            <textarea
              ref={ref}
              id="summary-textarea"
              className={classNames("form-element", className)}
              name="plotSummary"
              value={form.plotSummary}
              disabled={disableForm}
              onChange={onFormChange}
              placeholder={trans("Enter your plot summary")}
            />
            <ErrorField
              errorCondition={errorCondition}
              errorMessage={errorMessage}
              fieldId={"plot-summary"}
            />
          </React.Fragment>
        )}
      </FormValidation>
    </ContestFormField>
  );
};

PlotSummaryField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitted: PropTypes.bool.isRequired
};

export default PlotSummaryField;
